import { Injectable } from '@angular/core';
import { BaseNotifier } from '../../../../../shared/notifiers/base-notifier';
import { Ref } from '../../../../../shared/providers/ref';
import { TocState } from './toc-state';

@Injectable()
export class TocNotifier extends BaseNotifier<TocState> {
  constructor(ref: Ref) {
    super(ref, { visible: false });
  }

  toggle(): void {
    this.updateState(s => ({ ...s, visible: !s.visible }));
  }

  open(): void {
    this.updateState(s => ({ ...s, visible: true }));
  }

  close(): void {
    this.updateState(s => ({ ...s, visible: false }));
  }
}


